import type { FunctionComponent } from 'react';
import { Route, Routes } from 'react-router-dom';
import { GlobalNav } from '@fff-web/fff-global-nav';
import env from '../config/env';
import PersonalSurveyProvider from '../contexts/PersonalSurveyContext';
import PersonalSurvey from './personal-survey/PersonalSurvey';
import PrivateRoute from './private-route';
import ConfirmationPage from './trial-members/confirmation-page/ConfirmationPage';
import TrialMembers from './trial-members/TrialMembers';

const PERSONAL_SURVEY_INTRO_TEXT = `
  Fill out your Personal Survey so we can get to know you better!
  Your participation helps our team to understand what you and other members want to see in future boxes.
  After finishing the survey, you may be directed to customize your first box if Customization is currently open!
  Please note, this survey is not currently used to customize your boxes.
`;

const App: FunctionComponent = () => {
  const publicHeader = <GlobalNav env={env.ENVIRONMENT} />;

  return (
    <>
      <PersonalSurveyProvider>
        <Routes>
          <Route
            path="/personal-survey"
            element={
              <PrivateRoute>
                <PersonalSurvey welcomeText={PERSONAL_SURVEY_INTRO_TEXT} />
              </PrivateRoute>
            }
          />
          <Route
            path="/trial-survey"
            element={
              <PrivateRoute>
                <TrialMembers />
              </PrivateRoute>
            }
          />
          <Route
            path="/trial-survey/confirm"
            element={
              <PrivateRoute>
                <ConfirmationPage isTrial />
              </PrivateRoute>
            }
          />
          <Route
            path="/fabfitfun-survey-confirmation-3"
            element={<ConfirmationPage isTrial={false} header={publicHeader} />}
          />
        </Routes>
      </PersonalSurveyProvider>
    </>
  );
};

export default App;
